document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.js-inputArea').length) {
    
    let val;
    
    let type;
    
    let radio;
    
    let check;
    const inputArea = document.querySelector('.js-inputArea');
    const privacy = inputArea.querySelector('#js-privacy');
    let requireFlg = false;
    let privacyFlg = false;
    let errFlg = true;

    
    const radioButtons = inputArea.querySelectorAll('[type="radio"]:checked');
    radioButtons.forEach(button => {
      
      radio = button.value;
      
      const name = button.closest('[name]').name;
      
      document.querySelector(`[data-input-name="${name}"]`).textContent = radio;
      
    });

    
    const formInputs = inputArea.querySelectorAll('input, select, textarea');
    formInputs.forEach(input => {
      input.addEventListener('change', function () {
        
        val = this.value;
        
        type = this.getAttribute("type");

        if (type === "radio") {
          
          radio = this.value;
          
          const name = this.closest("[name]").name;
          
          document.querySelector(`[data-input-name="${name}"]`).textContent = radio;
        }
        else if (type === "checkbox") {
          if (input !== privacy) {

            
            check = this.value;
            
            const name = this.closest("[name]").name;
            
            document.querySelector(`[data-input-name="${name}"]`).textContent += check + " / ";
          }
        }
        else if (type === "file") { 
          
          const fileName = this.files[0].name;
          
          const name = this.closest("[name]").name;
          
          document.querySelector(`[data-input-name="${name}"]`).textContent = fileName;
        }
        else {
          

          
          const name = this.name;
          
          document.querySelector(`[data-input-name="${name}"]`).textContent = val;
        }
      });
    });

    
    const confirmButton = inputArea.querySelector(".js-confirmBtn");
    confirmButton.addEventListener('click', () => {
      document.querySelector(".js-inputArea").style.display = 'none';
      document.querySelector(".js-confirmArea").style.display = 'block';
      
      
      window.scrollTo(0, document.querySelector('.js-header').getBoundingClientRect().top);
    });


    const backButton = document.querySelector(".js-backBtn");
    backButton.addEventListener('click', () => {

      document.querySelector(".js-inputArea").style.display = '';
      document.querySelector(".js-confirmArea").style.display = 'none';


      window.scrollTo(0, document.querySelector('.js-header').getBoundingClientRect().top);
    });

    
    function setSubmitProp() {
      if (requireFlg && privacyFlg && !errFlg) {
        confirmButton.disabled = false;
      } else {
        confirmButton.disabled = true;
      }
    }

    
    privacy.addEventListener('change', function () {
      privacyFlg = (this.checked ? true : false);
      setSubmitProp();
    });

    
    const requiredInputs = inputArea.querySelectorAll('[aria-required="true"]');
    requiredInputs.forEach(input => {
      input.addEventListener('input', () => {
        
        let flag = true;
        
        requiredInputs.forEach(requiredInput => {
          if (requiredInput.value === "") {
            flag = false;
          }
        });
        
        requireFlg = flag;
        setSubmitProp();
      });
    });

    
    function errorCheck() {
      if (document.querySelector('.wpcf7-not-valid-tip')) {
        errFlg = true;
      } else {
        errFlg = false;
      }
    }

    requiredInputs.forEach(function (element) {
      element.addEventListener('blur', function () {
        errorCheck();
        setSubmitProp();
      });
    });
  }
});
